export const Guarantee = ["None", "Member", "Resort", "Credit Card"];

export const PercentageorFlatAmount = ["Percentage", "Flat Amount"];
